import WElmessage from "@/components/wrappers/w-elmessage.vue";

const displayError = (error: any, defaultMsg: string) => {
  WElmessage.showErrorMessage(error[0]?.message || error?.message || defaultMsg);
}

export default {
  displayError
}
